module.exports = __webpack_public_path__ + "static/img/icon-shop-canapply.ade08bd3.png";